/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ConversationEvaluationResultDto } from '../models';
// @ts-ignore
import type { EvaluateConversationRequestDto } from '../models';
/**
 * DevPlanEvalApi - axios parameter creator
 * @export
 */
export const DevPlanEvalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Evaluate a development-plan conversation (LLM-as-judge). Dev/testing tool.
         * @param {EvaluateConversationRequestDto} evaluateConversationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateConversation: async (evaluateConversationRequestDto: EvaluateConversationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'evaluateConversationRequestDto' is not null or undefined
            assertParamExists('evaluateConversation', 'evaluateConversationRequestDto', evaluateConversationRequestDto)
            const localVarPath = `/api/v1/dev-plan-eval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluateConversationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevPlanEvalApi - functional programming interface
 * @export
 */
export const DevPlanEvalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevPlanEvalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Evaluate a development-plan conversation (LLM-as-judge). Dev/testing tool.
         * @param {EvaluateConversationRequestDto} evaluateConversationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateConversation(evaluateConversationRequestDto: EvaluateConversationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConversationEvaluationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateConversation(evaluateConversationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevPlanEvalApi.evaluateConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevPlanEvalApi - factory interface
 * @export
 */
export const DevPlanEvalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevPlanEvalApiFp(configuration)
    return {
        /**
         * 
         * @summary Evaluate a development-plan conversation (LLM-as-judge). Dev/testing tool.
         * @param {EvaluateConversationRequestDto} evaluateConversationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateConversation(evaluateConversationRequestDto: EvaluateConversationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ConversationEvaluationResultDto> {
            return localVarFp.evaluateConversation(evaluateConversationRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevPlanEvalApi - interface
 * @export
 * @interface DevPlanEvalApi
 */
export interface DevPlanEvalApiInterface {
    /**
     * 
     * @summary Evaluate a development-plan conversation (LLM-as-judge). Dev/testing tool.
     * @param {EvaluateConversationRequestDto} evaluateConversationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevPlanEvalApiInterface
     */
    evaluateConversation(evaluateConversationRequestDto: EvaluateConversationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ConversationEvaluationResultDto>;

}

/**
 * DevPlanEvalApi - object-oriented interface
 * @export
 * @class DevPlanEvalApi
 * @extends {BaseAPI}
 */
export class DevPlanEvalApi extends BaseAPI implements DevPlanEvalApiInterface {
    /**
     * 
     * @summary Evaluate a development-plan conversation (LLM-as-judge). Dev/testing tool.
     * @param {EvaluateConversationRequestDto} evaluateConversationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevPlanEvalApi
     */
    public evaluateConversation(evaluateConversationRequestDto: EvaluateConversationRequestDto, options?: RawAxiosRequestConfig) {
        return DevPlanEvalApiFp(this.configuration).evaluateConversation(evaluateConversationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

